/**
 * Slideshow Russian Language Handler
 * This script adjusts the slideshow behavior for the Russian locale
 */
document.addEventListener('DOMContentLoaded', function() {
  // Only run this code if the page is in Russian
  if (document.documentElement.lang !== 'ru') return;
  
  console.log('[RU Slideshow] Starting slideshow adjustments for Russian locale');
  
  // Direct DOM manipulation to hide Collection Maison slides
  hideCollectionMaisonContent();
  
  // Process after a short delay to ensure DOM is ready
  setTimeout(function() {
    // Find and process the main slideshow
    const mainCarousel = document.getElementById('carousel-custom_slideshow_k3jaJJ');
    if (mainCarousel) {
      // Find carousel component
      const carouselComponent = mainCarousel.closest('slideshow-carousel');
      
      // Disable autoplay for Russian version to prevent automatic advancing to Collection Maison slide
      if (carouselComponent && carouselComponent.hasAttribute('autoplay')) {
        console.log('[RU Slideshow] Disabling autoplay for Russian locale');
        carouselComponent.removeAttribute('autoplay');
        
        // Add our custom controlled autoplay that skips Collection Maison
        setupCustomAutoplay(carouselComponent);
      }
      
      const collectionSlides = findCollectionMaisonSlides(mainCarousel);
      
      if (collectionSlides.length > 0) {
        console.log('[RU Slideshow] Found Collection Maison slides:', collectionSlides.length);
        
        // Hide the slides completely
        collectionSlides.forEach(slide => {
          slide.style.display = 'none';
          slide.remove(); // Completely remove from DOM
        });
        
        // Modify carousel dots
        const dots = mainCarousel.querySelectorAll('.page-dots button');
        if (dots.length === 3) {
          dots[2].style.display = 'none'; // Hide third dot
        }
      }
    }
    
    // Also hide standalone slideshow if present
    const standaloneSlideshow = document.getElementById('slideshow_PEdgNY');
    if (standaloneSlideshow) {
      console.log('[RU Slideshow] Hiding standalone Collection Maison slideshow');
      standaloneSlideshow.style.display = 'none';
      
      // Try to find parent section to hide it completely
      const parentSection = standaloneSlideshow.closest('.shopify-section');
      if (parentSection) {
        parentSection.style.display = 'none';
      }
    }
  }, 100);
  
  // Hook into any dynamic content loading
  observeDynamicContent();
});

/**
 * Setup custom controlled autoplay for Russian version that skips Collection Maison
 */
function setupCustomAutoplay(carousel) {
  if (!carousel) return;
  
  let currentSlideIndex = 0;
  const cycleSpeed = 5000; // Default to 5 seconds
  
  // Find all non-Collection Maison slides
  const allSlides = Array.from(carousel.querySelectorAll('.slideshow__slide'));
  
  // Get only visible slides (first and second)
  const visibleSlides = allSlides.filter((slide, index) => {
    return index < 2; // Only first two slides are visible in Russian version
  });
  
  console.log('[RU Slideshow] Setting up custom autoplay with', visibleSlides.length, 'slides');
  
  if (visibleSlides.length < 2) return; // No need for autoplay if only one slide is visible
  
  // Create custom autoplay interval
  const autoplayInterval = setInterval(() => {
    currentSlideIndex = (currentSlideIndex + 1) % visibleSlides.length;
    console.log('[RU Slideshow] Auto-advancing to slide', currentSlideIndex);
    
    // Use the carousel's API to navigate to the next slide
    carousel.select(currentSlideIndex, true);
  }, cycleSpeed);
  
  // Clear interval when page visibility changes
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearInterval(autoplayInterval);
    } else {
      // Restart interval
      clearInterval(autoplayInterval);
      setupCustomAutoplay(carousel);
    }
  });
  
  // Add custom event listener to track user interactions
  carousel.addEventListener('click', () => {
    // Reset the current index when user interacts with carousel
    const selectedSlide = carousel.querySelector('.slideshow__slide.is-selected');
    if (selectedSlide) {
      currentSlideIndex = visibleSlides.indexOf(selectedSlide);
    }
    
    // Reset the timer
    clearInterval(autoplayInterval);
    setupCustomAutoplay(carousel);
  });
}

/**
 * Find any slides containing Collection Maison content
 */
function findCollectionMaisonSlides(container) {
  const slides = [];
  
  // Look for slides with data attribute
  const taggedSlides = container.querySelectorAll('.slideshow__slide[data-collection-maison-slide="true"]');
  if (taggedSlides.length > 0) {
    taggedSlides.forEach(slide => slides.push(slide));
  }
  
  // Look for slides with Collection Maison content
  const allSlides = container.querySelectorAll('.slideshow__slide');
  allSlides.forEach(slide => {
    // Check if this slide wasn't already added
    if (!slides.includes(slide)) {
      // Check for Collection Maison in title or links
      const titleElements = slide.querySelectorAll('.prose p.h1');
      let containsCollectionMaison = false;
      
      titleElements.forEach(titleEl => {
        if (titleEl.textContent.includes('COLLECTION MAISON')) {
          containsCollectionMaison = true;
        }
      });
      
      // Check links
      const links = slide.querySelectorAll('a[href*="collection-maison"]');
      if (links.length > 0) {
        containsCollectionMaison = true;
      }
      
      if (containsCollectionMaison) {
        slides.push(slide);
      }
    }
  });
  
  return slides;
}

/**
 * Aggressively target and hide any Collection Maison content
 */
function hideCollectionMaisonContent() {
  // Find all HTML elements containing "collection-maison" in href or content
  const elements = document.querySelectorAll('a[href*="collection-maison"], [data-collection-maison-slide="true"]');
  
  elements.forEach(el => {
    // If it's a link, check if it's inside a slide or collection item
    if (el.tagName === 'A') {
      let parent = el;
      // Walk up to find relevant container
      while (parent && !parent.classList.contains('slideshow__slide') && 
             !parent.classList.contains('collection-item-collection-carrousel')) {
        parent = parent.parentElement;
      }
      
      if (parent) {
        console.log('[RU Slideshow] Hiding Collection Maison container:', parent);
        parent.style.display = 'none';
        if (parent.parentElement) {
          // Try to remove from DOM to prevent any issues
          parent.parentElement.removeChild(parent);
        }
      }
    } else {
      console.log('[RU Slideshow] Hiding Collection Maison element:', el);
      el.style.display = 'none';
      if (el.parentElement) {
        el.parentElement.removeChild(el);
      }
    }
  });
  
  // Specifically target the third slider in custom_slideshow_k3jaJJ
  const mainSlideshow = document.getElementById('carousel-custom_slideshow_k3jaJJ');
  if (mainSlideshow) {
    const slides = mainSlideshow.querySelectorAll('.slideshow__slide');
    if (slides.length === 3) {
      // In custom_slideshow_k3jaJJ, the Collection Maison is the 3rd slide
      const thirdSlide = slides[2]; 
      console.log('[RU Slideshow] Hiding third slide which contains Collection Maison');
      thirdSlide.style.display = 'none';
      thirdSlide.remove();
    }
  }
}

/**
 * Observe the DOM for any dynamically added content
 */
function observeDynamicContent() {
  // Create an observer to watch for dynamically added slides
  const observer = new MutationObserver(function(mutations) {
    let shouldProcessChanges = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        shouldProcessChanges = true;
      }
    });
    
    if (shouldProcessChanges) {
      console.log('[RU Slideshow] DOM changes detected, re-hiding Collection Maison content');
      hideCollectionMaisonContent();
    }
  });
  
  // Observe the entire body for changes
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
} 